import axios from "axios";

export const TRUTH_ACK_EVENT = "hg-truth-ack-request";

export const isTruthAckRequired = (err) =>
  err?.response?.status === 409 && err.response.data?.detail?.code === "truth_ack_required";

// Ask the clinician (via TruthAckDialog) for a warn-mode reason. Resolves to the reason, or null if they cancel.
export const requestTruthAck = (detail) =>
  new Promise((resolve) => window.dispatchEvent(new CustomEvent(TRUTH_ACK_EVENT, { detail: { ...detail, resolve } })));

const plainHeaders = (h) => (h && typeof h.toJSON === "function" ? h.toJSON() : { ...(h || {}) });

// Warn mode: when a save needs a reason, ask for it once and resend the same request with the reason attached.
export function installTruthAckInterceptor(instance = axios) {
  instance.interceptors.response.use((r) => r, async (error) => {
    if (!isTruthAckRequired(error) || error.config?._truthAck) return Promise.reject(error);
    const reason = await requestTruthAck(error.response.data.detail);
    if (!reason) return Promise.reject(error);
    const headers = { ...plainHeaders(error.config.headers), "X-Truth-Ack-Reason": encodeURIComponent(reason) };
    if (typeof FormData !== "undefined" && error.config.data instanceof FormData) delete headers["Content-Type"];
    return instance.request({ ...error.config, headers, _truthAck: true });
  });
}
